import React from 'react';
import { Type } from '@spotify-internal/encore-web-v6';
import { useT } from '../../../../../features/src/i18n/index';
import { FooterNavLink, LinkType } from '../Components/FooterNavLink';
import { TRACK_CAT } from '../constants';
import styled from 'styled-components';

const LinkList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
`;

export const HelpfulLinks = () => {
  const t = useT();
  const links: LinkType[] = [
    {
      href: 'https://www.spotify.com/about-us/contact/',
      track: [TRACK_CAT, 'About'],
      dataTestId: 'footer-about',
      label: t('FRODOR_2b48af', 'About', ''),
      prefetch: true,
      external: true,
    },
    {
      href: 'https://newsroom.spotify.com',
      track: [TRACK_CAT, 'Press & Media'],
      dataTestId: 'footer-press-and-media',
      label: t(
        'FRODOR_f24f14',
        'Press & Media',
        'Press means newspapers or journalists viewed collectively',
      ),
      prefetch: true,
      external: true,
    },
    {
      href: '/providers',
      track: [TRACK_CAT, 'Providers'],
      dataTestId: 'footer-providers',
      label: t('FRODOR_83327b', 'Providers', ''),
      prefetch: true,
      external: true,
    },
    {
      href: '/contact',
      track: [TRACK_CAT, 'Contact Us'],
      dataTestId: 'footer-contact',
      label: t('FRODOR_51f8e4', 'Contact Us', ''),
      prefetch: false,
      external: false,
    },
  ];
  return (
    <>
      <Type variant="finaleBold" semanticColor="textBase">
        {t(
          'FRODOR_0aeec8',
          'Helpful Links',
          'Link refers to web link',
        ).toUpperCase()}
      </Type>
      <LinkList>
        {links.map(link => {
          return <FooterNavLink key={link.label} link={link} />;
        })}
      </LinkList>
    </>
  );
};
